export default {
  INITIAL_ORDERS_RECEIVED: 'NOTIFICATIONS/INITIAL_ORDERS_RECEIVED',
  ORDER_RECEIVED: 'NOTIFICATIONS/ORDER_RECEIVED',
  READ_KITCHEN_COMPLETED_MESSAGES: 'NOTIFICATIONS/READ_KITCHEN_COMPLETED_MESSAGES',
  PRUNE: 'NOTIFICATIONS/PRUNE',
};
